import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=53f82f0a&"
import script from "./SnackbarNotification.vue?vue&type=script&lang=ts&"
export * from "./SnackbarNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports